import React from "react";
import { Switch } from "@warp-ds/react";
import { Description, GridLayout, GridLeft, GridRight, Name } from "../styles";
import { useAppTranslation } from "../../locales/translate";

type Props = {
  name: string;
  description: string;
  value: boolean;
  handleToggleNotifications: () => void;
};

export const toSwitchLabelId = (channelName: string) =>
  `alert-${channelName.toLowerCase()}`;

export const SavedSearchSettingsChannelItem = ({
  name,
  value,
  description,
  handleToggleNotifications,
}: Props) => {
  const { t } = useAppTranslation();

  const switchLabelId = toSwitchLabelId(name);

  return (
    <GridLayout>
      <GridLeft>
        <Name id={switchLabelId}>{name}</Name>
        <Description>{description}</Description>
      </GridLeft>

      <GridRight>
        <Switch
          value={value}
          onClick={handleToggleNotifications}
          aria-label={t("SETTING_CHANNEL_TOGGLE_ARIA_LABEL")}
          aria-labelledby={switchLabelId}
        />
      </GridRight>
    </GridLayout>
  );
};
